module.exports = __webpack_public_path__ + "static/media/_MIC2294.thumbnail.ab4be84b.png";